import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  title: string;
  message: string;
  dialogData !: any;
  noButton: boolean;
  showInput: boolean = false;
  inputPlaceholder: string = '';
  inputValue: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) { }

  ngOnInit() {
    this.message = this.data.message;
    this.title = this.data.title;
    if (this.data.noButton != null && this.data.noButton != undefined)
      this.noButton = this.data.noButton;
    else
      this.noButton = true;

    // Support for input field
    if (this.data.showInput) {
      this.showInput = true;
      this.inputPlaceholder = this.data.inputPlaceholder || 'Enter value';
    }
  }

  onConfirm(): void {
    if (this.showInput) {
      this.dialogRef.close({ confirmed: true, inputValue: this.inputValue });
    } else {
      this.dialogRef.close(true);
    }
  }

  onCancel(): void {
    if (this.showInput) {
      this.dialogRef.close({ confirmed: false, inputValue: '' });
    } else {
      this.dialogRef.close(false);
    }
  }
}
